import { WidthWrapper } from 'components'
import TabsList from 'components/TabsList'
import { OwnedTopicsTab } from 'modules/territory'

import type { IListGlobalTopicsPage } from './list-global-topics-page.types'
import { GlobalTopicFavoriteList } from '../global-topic-favorite-list'
import { GlobalTopicListTab } from '../global-topic-list-tab'
import './list-global-topics-page.styles.scss'

export const ListGlobalTopicsPageView = ({ tabs, currentTab }: IListGlobalTopicsPage) => {
  return (
    <WidthWrapper>
      <div className="ListGlobalTopicsPage">
        <TabsList tabs={tabs} />
        <div>
          {currentTab === 'owned' && <OwnedTopicsTab />}
          {currentTab === 'territories' && <GlobalTopicListTab />}
          {currentTab === 'favorites' && <GlobalTopicFavoriteList />}
        </div>
      </div>
    </WidthWrapper>
  )
}
